import React from 'react';

export default () => <p>Privacy Policy</p>